import React, {useState} from 'react';
import {connect} from "react-redux";
import classnames from 'classnames';
import { EditIcon, PlusIcon } from '../../Components/Icons/Icons';
import { useHistory } from 'react-router';
import {setActiveStepAction, setActiveGuestAction, startGuestProgress} from "~/redux/actions/guests";

import PersonalDetails from "./PersonalDetails";
import SpecialRequirements from "./SpecialRequirements";
import HotelRooms from "./HotelRooms";
import Travel from './Travel';
import Emergency from './Emergency';
import Documents from './Documents';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

const GuestPreview = ({guest, invitation, index, ...props}) => {

    const [loading, setLoading] = useState(false);
    const history = useHistory();

    function handleEditInfo (tab) {
        window.scrollTo(0, 0);
        props.dispatch(setActiveGuestAction(index));
        props.dispatch(setActiveStepAction(tab));
        history.push('/registration');
    }

    const handleStartGuest = (guest) => {
        setLoading(true);
        props.dispatch(startGuestProgress(guest.id)).then(() => {
            handleEditInfo('personal_details');
        }).finally(() => setLoading(false));
    }

    const submitted = invitation.registration_status === 'submitted';


    const startedGuest = (
        <div
            className={classnames([
                "guest-preview-card card shadow-sm bg-white",
                {"mt-3": index > 0}
            ])}
        >
            <div className="card-body p-0">
                <div className="head row no-gutters">
                    <div className="col-12 text-type-caption">
                        {guest.main ?
                            <TextTranslate name="reg-main-guest" fallback="Main Guest"/> :
                            <><TextTranslate name="reg-guest-number" fallback="Guest #"/> {index}</>
                        }
                    </div>
                    <div className="col-12 guest-name">{guest.first_name} {guest.last_name}</div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-start">
                            <h3><TextTranslate name="form-personal-details" fallback="Personal Details"/></h3>
                            {!submitted && (
                                <div
                                    className="btn btn-secondary btn-sm text-uppercase d-none d-lg-flex"
                                    onClick={() => handleEditInfo('personal_details')}
                                >
                                    <EditIcon classes="d-inline-block mr-2"/>
                                    <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                </div>
                            )}
                        </div>
                        <PersonalDetails guest={guest} />
                        {!submitted && (
                            <div
                                className="btn btn-secondary btn-sm text-uppercase d-flex d-lg-none mt-4"
                                onClick={() => handleEditInfo('personal_details')}
                            >
                                <EditIcon classes="d-inline-block mr-2"/>
                                <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                            </div>
                        )}
                    </div>
                </div>
                {invitation.package.steps.special_requirements && (
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-start">
                                <h3><TextTranslate name="form-special-requirements" fallback="Special Requirements" textOnly/></h3>
                                {!submitted && (
                                    <div
                                        className="btn btn-secondary btn-sm text-uppercase d-none d-lg-flex"
                                        onClick={() => handleEditInfo('special_requirements')}
                                    >
                                        <EditIcon classes="d-inline-block mr-2"/>
                                        <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                    </div>
                                )}
                            </div>
                            <SpecialRequirements guest={guest} />
                            {!submitted && (
                                <div
                                    className="btn btn-secondary btn-sm text-uppercase d-flex d-lg-none mt-4"
                                    onClick={() => handleEditInfo('special_requirements')}
                                >
                                    <EditIcon classes="d-inline-block mr-2"/>
                                    <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {(invitation.package.steps.hotel_rooms && guest.main) && (
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-start">
                                <h3><TextTranslate name="form-hotel-rooms" fallback="Hotel Rooms" textOnly/></h3>
                                {!submitted && (
                                    <div
                                        className="btn btn-secondary btn-sm text-uppercase d-none d-lg-flex"
                                        onClick={() => handleEditInfo('hotel_rooms')}
                                    >
                                        <EditIcon classes="d-inline-block mr-2"/>
                                        <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                    </div>
                                )}
                            </div>
                            <HotelRooms guest={guest} />
                            {!submitted && (
                                <div
                                    className="btn btn-secondary btn-sm text-uppercase d-flex d-lg-none mt-4"
                                    onClick={() => handleEditInfo('hotel_rooms')}
                                >
                                    <EditIcon classes="d-inline-block mr-2"/>
                                    <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {invitation.package.steps.travel && (
                    <div className="row">
                        <div className="col-12 flight-preview">
                            <div className="d-flex justify-content-between align-items-start">
                                <h3>
                                    <TextTranslate name="form-travel" fallback="Flights & Travel" textOnly/>
                                </h3>
                                {!submitted && (
                                    <div
                                        className="btn btn-secondary btn-sm text-uppercase d-none d-lg-flex"
                                        onClick={() => handleEditInfo('travel')}
                                    >
                                        <EditIcon classes="d-inline-block mr-2"/>
                                        <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                    </div>
                                )}
                            </div>
                            <Travel guest={guest} />
                            {!submitted && (
                                <div
                                    className="btn btn-secondary btn-sm text-uppercase d-flex d-lg-none mt-4"
                                    onClick={() => handleEditInfo('travel')}
                                >
                                    <EditIcon classes="d-inline-block mr-2"/>
                                    <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {invitation.package.steps.emergency_contact && (
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-start">
                                <h3>
                                    <TextTranslate name="form-emergency-contact" fallback="Emergency Contact" textOnly/>
                                </h3>
                                {!submitted && (
                                    <div
                                        className="btn btn-secondary btn-sm text-uppercase d-none d-lg-flex"
                                        onClick={() => handleEditInfo('emergency_contact')}
                                    >
                                        <EditIcon classes="d-inline-block mr-2"/>
                                        <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                    </div>
                                )}
                            </div>
                            <Emergency guest={guest} />
                            {!submitted && (
                                <div
                                    className="btn btn-secondary btn-sm text-uppercase d-flex d-lg-none mt-4"
                                    onClick={() => handleEditInfo('emergency_contact')}
                                >
                                    <EditIcon classes="d-inline-block mr-2"/>
                                    <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {invitation.package.steps.documents && (
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-start">
                                <h3><TextTranslate name="form-documents" fallback="Supporting Documents" textOnly/></h3>
                                {!submitted && (
                                    <div
                                        className="btn btn-secondary btn-sm text-uppercase d-none d-lg-flex"
                                        onClick={() => handleEditInfo('documents')}
                                    >
                                        <EditIcon classes="d-inline-block mr-2"/>
                                        <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                    </div>
                                )}
                            </div>
                            <Documents guest={guest} />
                            {!submitted && (
                                <div
                                    className="btn btn-secondary btn-sm text-uppercase d-flex d-lg-none mt-4"
                                    onClick={() => handleEditInfo('documents')}
                                >
                                    <EditIcon classes="d-inline-block mr-2"/>
                                    <TextTranslate name="word-edit" fallback="Edit" textOnly/>
                                </div>
                            )}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );

    const notStartedGuest = (
        <div
            className={classnames([
                "guest-preview-card card shadow-sm bg-white",
                {"mt-3": index > 0}
            ])}
        >
            <div className="card-body p-0">
                <div className="head row no-gutters">
                    <div className="col-12 text-title-l">
                        {guest.main ?
                            <TextTranslate name="reg-main-guest" fallback="Main Guest" textOnly/> :
                            <><TextTranslate name="reg-guest-number" fallback="Guest #"/> {index}</>
                        }
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-12">
                        <p>
                            {guest.main ?
                                <TextTranslate name="reg-main-guest" fallback="Main Guest" textOnly/> :
                                <><TextTranslate name="reg-guest-number" fallback="Guest #"/> {index}</>
                            } <TextTranslate name="regpreview-guest-not-setup-msg" fallback="has not been set up. If you confirm your registration without providing any details for this guest, you will lose this space as part of your invitation." textOnly/>
                        </p>
                        <p className="mt-3">
                            <TextTranslate name="regpreview-noguest-contact-msg" fallback={`If you have any question, you can contact us at <a href="mailto:NEOMexperiences@csm.com" className="link text-primary">NEOMexperiences@csm.com.</a>`}/>
                        </p>
                    </div>
                    <div className="col-12 position-relative">
                        <button
                            disabled={loading}
                            className="setupguest mt-4 btn btn-secondary btn-sm text-uppercase"
                            onClick={() => handleStartGuest(guest)}
                        >
                            <PlusIcon/>
                            <span className="icon-center-adjustment">
                                <TextTranslate name="regpreview-button-setupguest" fallback="Set up guest" textOnly/>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )

    if (guest.started) {
        return startedGuest;
    }

    if (submitted) {
        return <></>;
    }

    return notStartedGuest;
}

const mapStateToProps = (state) => ({
    invitation: state.invitation?.data,
    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep[state.guests?.activeGuest],
});

export default connect(mapStateToProps)(GuestPreview);
